import React, { useState, useEffect } from 'react';
import MediaModal from './MediaModal';
import { FILE_URL, NO_IMG } from '../../constants';
import LazyLoadImage from '../LazyLoadImage';

function SingleMediaUpload({ name, defaultFile, onChange, authToken }) {
    const [modalShow, setModalShow] = useState(false);
    const [selectedFile, setSelectedFile] = useState(defaultFile);

    // Sync selectedFile with defaultFile when it changes
    useEffect(() => {
        setSelectedFile(defaultFile);
    }, [defaultFile]);

    // Handle the selection of a file
    const handleFileSelect = (file) => {
        setSelectedFile(file); // Set the selected file
        if (onChange) {
            onChange(name, file); // Trigger the onChange callback with the selected file
        }
    };

    // Handle clearing the selected file
    const handleClearSelection = (e) => {
        e.stopPropagation();
        setSelectedFile(null); // Clear the selected file
        if (onChange) {
            onChange(name, ''); // Notify parent with an empty string or null
        }
    };

    return (
        <div className="mb-3">
            {/* Image Display Area */}
            <div className="d-flex align-items-center position-relative border bg-body-secondary rounded-2" style={{ width: '100px', aspectRatio: '1', cursor: 'pointer' }}>
                <label className="select-labele" htmlFor={name} style={{ width: '100px', aspectRatio: '1' }}>
                    <img
                        src={selectedFile ? `${FILE_URL}${selectedFile}` : NO_IMG} // Use selectedFile or a placeholder image
                        alt={name}
                        className="select-image w-100 h-100"
                        style={{ objectFit: 'cover' }}
                    />
                </label>

                {/* Hidden radio button triggers the modal */}
                <input
                    id={name}
                    type="radio"
                    name={name}
                    className="position-absolute top-0 end-0 opacity-0"
                    onClick={() => setModalShow(true)} // Open modal on click
                    value="Select"
                />

                {/* Clear button */}
                {selectedFile && (
                    <button
                        type="button"
                        className="btn btn-primary p-0 px-1 rounded-4 position-absolute top-0 end-0 m-1"
                        onClick={handleClearSelection}
                    >
                        <i className="bi bi-x"></i>
                    </button>
                )}
            </div>

            {/* Hidden input to submit the selected file's URL */}
            <input type="hidden" name={name} value={selectedFile || ''} />

            {/* Media Modal */}
            {modalShow && (
                <MediaModal
                    show={modalShow}
                    onHide={() => setModalShow(false)} // Close modal
                    onSelectImage={handleFileSelect} // Pass selected file to handleFileSelect
                    mode="single" // Single mode for selecting one file
                    authToken={authToken} // Pass authToken for authentication
                />
            )}
        </div>
    );
}

export default SingleMediaUpload;
